
<mat-list class="menulist">
  <mat-accordion multi="false">

    <ng-container *ngFor="let item of menu">
      <!-- If the item doesn't have children, show it as list item -->
      <ng-container *ngIf="!item?.subMenuflag">
        <mat-list-item *ngIf="item?.title" [ngClass]="{'active': isActive(item)}"
          class="center-flex">
          <div (click)="navigateToRoute(item)" class="d-inline-flex list_item align-items-center" [ngClass]="{ 'disabled': item?.disable }">
            <i style="font-size: 20px;" [ngClass]="[
            'fa-solid', 
            item.icon, 
            'icon'
          ]">
            </i>
            <!-- <img [src]="isActive(item) ? item?.active_icon : item?.icon" alt="menu logo" /> -->
            <span matLine>{{ (item.title ?? '') | translatepipe }}</span>
          </div>
        </mat-list-item>
      </ng-container>
      <!-- </ng-container> -->

      <!-- Wrap all expandable menu items inside a single mat-accordion -->
      <!-- <ng-container *ngFor="let item of menu"> -->
      <ng-container *ngIf="item?.subMenuflag">
        <div class="d-inline-flex list_item align-items-center menuitom" [ngClass]="{ 'disabled': item?.disable }">
          <i style="font-size: 20px;" [ngClass]="[ 'icon', 'fa-solid',  item.icon]"></i>
          <span (click)="onToggleClick(item)" matLine style="width: 80%;cursor: pointer;" [ngClass]="{ 'expanded-header': item.expanded }">{{ (item.title ?? '') | translatepipe}}</span>
          @if(item.expanded){
          <a (click)="onToggleClick(item)">
              <i class="menuicon" [ngClass]="['fa-solid', 'fa-chevron-up','icon']"></i>
          </a>
          }
          @if(!item.expanded){
          <a class="inactionicon"  (click)="onToggleClick(item)">
            <i class="menuicon" [ngClass]="['fa-solid', 'fa-chevron-down','icon']"></i>
          </a>
          }
        </div>

        <mat-expansion-panel [disabled]="item?.disable" [expanded]="item.expanded" [hideToggle]="true">
    
          <!-- <mat-expansion-panel-header style="pointer-events: none;">
            <mat-panel-title class="center-flex">
              <div class="d-inline-flex list_item align-items-center">
                <i 
                style="font-size: 20px;"
                [ngClass]="[
                  'icon',
                  'fa-solid', 
                  item.icon
                ]">
              </i>
                <img [src]="item.expanded ? item?.active_icon : item?.icon" alt="menu logo" />
                <span matLine [ngClass]="{ 'expanded-header': item.expanded }">{{ item?.title }}</span>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header> -->

          <!-- Submenu items -->
          <ng-container *ngFor="let submenu of item.SubMenu">
            <mat-list-item *ngIf="submenu?.title" [routerLink]="submenu?.link" routerLinkActive="active"
              class="ps-25 center-flex" [disabled]="submenu?.disable" [ngClass]="{'active': isActive(submenu)}">
              <div class="d-inline-flex list_item align-items-center">
                <!-- <i 
                style="font-size: 20px;"
                [ngClass]="[
                  'fa-solid', 
                  submenu.icon, 
                  'icon'
                ]">
              </i> -->
                <!-- <img [src]="isActive(submenu) ? item?.active_icon : item?.icon" alt="menu logo" /> -->
                <span matLine>{{ (submenu?.title ?? '' | translatepipe) }}</span>
              </div>
            </mat-list-item>
          </ng-container>
        </mat-expansion-panel>
      </ng-container>
    </ng-container>
  </mat-accordion>
</mat-list>